import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Grid, Avatar, Menu, MenuItem, Divider } from "@mui/material";
import { IoIosSearch } from "react-icons/io";
import { useAuth } from "../../../contextApi/ContextApi";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/KrishL_logo.jpg";
import icon from "../../../assets/images/icons.gif";
export default function Header() {
  const { setFilter } = useAuth();
  const navigate = useNavigate();
  // ✅ ALL hooks at top
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openSearch, setOpenSearch] = React.useState(false);
  const [selectedButton, setSelectedButton] = React.useState("Pending");
  const [typographyWidth, setTypographyWidth] = React.useState("330px");

  const open = Boolean(anchorEl);

  // ✅ Read localStorage safely
  let loginData = null;
  try {
    loginData = JSON.parse(localStorage.getItem("LoginData"));
  } catch (e) {
    loginData = null;
  }

  // ✅ Handlers
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleOpenSearch = () => {
    setOpenSearch(!openSearch);
    setTypographyWidth(openSearch ? "330px" : "auto");
  };

  const handleButtonClick = (button) => {
    setSelectedButton(button);
    setFilter(button);
  };

  const isButtonSelected = (button) => button === selectedButton;

  return (
    <Box>
      <AppBar
        position="static"
        sx={{
          color: "black",
         boxShadow:"none",
          position: "fixed",
          top: "0",
          zIndex: "100",
        }}
      >
        <Toolbar
          className="justify-content-between"
          sx={{
            borderBottom: "2px solid white",
             backgroundColor: "#fdb913 ",
          }}
        >
          <Typography
            variant="h6"
            noWrap
            sx={{
              color: "black",
              fontSize: "20px",
              marginRight: "10px",
              width: typographyWidth,
            }}
          >
            <img src={Logo} height={35} alt="" /> Orders
          </Typography>

          <Grid
            container
            style={{ position: "relative" }}
            alignItems="center"
            justifyContent="end"
          >
            <Grid
              item
              onMouseEnter={loginData ? handleOpen : undefined}
              onMouseLeave={loginData ? handleClose : undefined}
              sx={{ cursor: loginData ? "pointer" : "default" }}
            >
              {/* USER ICON + NAME */}
              <Box display="flex" alignItems="center" gap={1}>
                <Avatar
                  src={icon|| ""}
                  sx={{ width: 25, height: 25 }}
                >
        
                </Avatar>
                <Typography fontSize={20} fontWeight="600">
                  {loginData?.UserName || "Guest"}
                </Typography>
              </Box>

              {/* DROPDOWN */}
              {loginData && (
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  disableScrollLock
                  PaperProps={{ sx: { mt: 1, minWidth: 240 } }}
                  MenuListProps={{
                    onMouseEnter: () => setAnchorEl(anchorEl),
                    onMouseLeave: handleClose,
                  }}
                >
                  <Box px={2} py={1}>
                    {/* <Typography fontWeight={600}>
                      {loginData.UserName}
                    </Typography> */}
                    <Typography fontSize={15}>
                      📱 +91 {loginData.MobileNo}
                    </Typography>
                    {loginData.Address && (
                      <Typography fontSize={15} mt={0.5}>
                        📍 {loginData.Address}
                      </Typography>
                    )}
                  </Box>

                  <Divider />

                  <MenuItem
                    sx={{ fontSize: "17px" }}
                    style={{
                      border: "1px solid",
                      justifyContent: "center",
                      borderRadius: "10px",
                      margin: "10px",
                      background: "#ff0000ff",
                      color: "white",
                    }}
                    onClick={() => {
                      localStorage.removeItem("LoginData");
                      navigate("/login");
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              )}
            </Grid>
          </Grid>
        </Toolbar>

        <Grid
          container
          justifyContent={"space-between"}
          flexWrap={"nowrap"}
          sx={{
            overflowX: "auto",
            "&::-webkit-scrollbar": { display: "none" },
            display: "flex",
            cursor: "pointer",
            whiteSpace: "nowrap",
            background:"white"
          }}
          width={"100%"}
          gap={2}
          className="p-2 overflow-scroll"
        >
          {["Pending", "Delivered","Scheduled", "Cancelled", "All"].map(
            (buttonText, index) => (
              <Grid
                key={index}
                style={{ borderRadius: "40px" }}
                className={`p-2 px-3  ${
                  isButtonSelected(buttonText)
                    ? "border border-danger text-white bg-danger"
                    : "border border-dark"
                }`}
                sx={{ display: "flex", cursor: "pointer" }}
                onClick={() => handleButtonClick(buttonText)}
              >
                <Typography className="css-ahj2mt-MuiTypography-root">{buttonText}</Typography>
              </Grid>
            )
          )}
        </Grid>
  
      </AppBar>
    </Box>
  );
}
